// src/components/GalleryGrid/GalleryGrid.jsx
import React from 'react';
import styles from './GalleryGrid.module.css';

// This component just provides the grid structure
const GalleryGrid = ({ children }) => {
    return (
        <div className={styles.galleryGrid}>
            {children}
        </div>
    );
};

export default GalleryGrid;